import { render, staticRenderFns } from "./ChargeODExtension.vue?vue&type=template&id=3c320543"
import script from "./ChargeODExtension.vue?vue&type=script&lang=js"
export * from "./ChargeODExtension.vue?vue&type=script&lang=js"
import style0 from "./ChargeODExtension.vue?vue&type=style&index=0&id=3c320543&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports